import React, { useMemo } from 'react';
import { View } from 'react-native';
import useColors from 'hooks/useColors';
import Button from './Button';
import Spacer from './Spacer';
import Text from './Text';
import ModalHandle from './ModalHandle';
const ModalConfirmationContent = ({ title, subtitle, options, onPress, onPressCancel, containerStyle, }) => {
    const colors = useColors();
    const subtitleNode = useMemo(() => {
        if (typeof subtitle === 'string') {
            return (<Text TextThin-14 Gray centered>
          {subtitle}
        </Text>);
        }
        if (Array.isArray(subtitle)) {
            return (<>
          {subtitle.map((paragraph, index) => (<React.Fragment key={index}>
              {index > 0 && <Spacer h={10}/>}
              <Text TextThin-14 Gray centered>
                {paragraph}
              </Text>
            </React.Fragment>))}
        </>);
        }
        return subtitle;
    }, [subtitle]);
    return (<View style={[
            containerStyle,
            {
                backgroundColor: options?.lightBg
                    ? colors.cards.onLight
                    : colors.cards.onDark,
            },
        ]}>
      {!options?.hideHandle && !options?.fullscreen && <ModalHandle />}
      <Text Text-20 centered>
        {title}
      </Text>
      {subtitleNode ? (<>
          <Spacer h={16}/>
          {subtitleNode}
        </>) : null}
      <Spacer h={24}/>
      <Button {...(options.brandReversedConfirm ||
        options.cancelButtonTitle !== undefined
        ? { brandReversed: true }
        : { brand: true })} title={options.confirmButtonTitle ?? 'OK'} onPress={onPress} leftIcon={options.confirmButtonLeftIcon}/>
      {options.cancelButtonTitle !== undefined ? (<>
          <Spacer h={8}/>
          <Button brand onPress={onPressCancel} title={options.cancelButtonTitle}/>
        </>) : null}
    </View>);
};
export default ModalConfirmationContent;
